module.exports = __webpack_public_path__ + "media/images/yardage_mark_3-a09da301c060f8f76da50830ab70bb86.png";